export enum TemplateFilterSlotCountEnum {
  All = 'all',
  Zero = 0,
  One = 1,
  Two = 2,
  Three = 3,
  Four = 4,
  FivePlus = '5+',
}
